import { bindable, customElement } from 'aurelia';
import template from './tag-group-modal.html';
import type { TagGroup } from '../services/api.types';
import { createTagGroup, updateTagGroup } from '../services/api.service';

@customElement({ name: 'tag-group-modal', template })
export class TagGroupModal {
  @bindable public saved!: (group: TagGroup) => void;
  @bindable public closed!: () => void;
  @bindable public groupToEdit: TagGroup | null = null;

  public name = '';
  public saving = false;
  public error = '';

  private _keyHandler!: (e: KeyboardEvent) => void;

  public get isEditMode(): boolean { return this.groupToEdit !== null; }

  public attached(): void {
    this.name = this.groupToEdit?.name ?? '';
    this._keyHandler = (e: KeyboardEvent) => { if (e.key === 'Escape') this.close(); };
    document.addEventListener('keydown', this._keyHandler);
  }

  // Called by Aurelia when the groupToEdit binding changes (handles component reuse)
  public groupToEditChanged(): void {
    this.name = this.groupToEdit?.name ?? '';
    this.error = '';
  }

  public detached(): void {
    document.removeEventListener('keydown', this._keyHandler);
  }

  public close(): void { this.closed(); }

  public async save(): Promise<void> {
    if (!this.name.trim()) { this.error = 'Name is required.'; return; }
    this.saving = true;
    this.error = '';
    try {
      let group: TagGroup;
      if (this.isEditMode && this.groupToEdit) {
        group = await updateTagGroup(this.groupToEdit.id, this.name.trim());
      } else {
        group = await createTagGroup(this.name.trim());
      }
      this.saved(group);
    } catch (e: unknown) {
      this.error = e instanceof Error ? e.message : String(e);
    } finally {
      this.saving = false;
    }
  }
}
